
class CapViewRoutePullEntry {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_route_pull_entry'
}

function create(config) {
  return new CapViewRoutePullEntry(config)
}

export default {
  key,
  create,
}
